import { useReducer, useRef } from 'react'

export function FontSizeSelector() {
  const tooltipRef = useRef<HTMLDivElement>(null)
  const [value, setValue] = useReducer(
    (state, newValue: string) => {
      document.documentElement.style.setProperty('--font-size', `${newValue}px`)

      return Number(newValue)
    },
    0,
    () => {
      return Number(
        window
          .getComputedStyle(document.documentElement)
          .getPropertyValue('--font-size')
          .replace(/\D/g, '')
      )
    }
  )
  return (
    <div className="font-size-block my-2 p-3">
      <div className="w-1/6 inline-block">
        <svg
          className="svg-inline--fa fa-font-case fa-sm"
          aria-hidden="true"
          focusable="false"
          data-prefix="fad"
          data-icon="font-case"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 640 512"
        >
          <g className="fa-duotone-group">
            <path
              className="fa-secondary"
              fill="currentColor"
              d="M384 288l0 64c0 70.7 57.3 128 128 128c24.5 0 47.4-6.9 66.8-18.8c5 11.1 16.2 18.8 29.2 18.8c17.7 0 32-14.3 32-32l0-96 0-64 0-96c0-17.7-14.3-32-32-32c-13 0-24.1 7.7-29.2 18.8C559.4 166.9 536.5 160 512 160c-70.7 0-128 57.3-128 128zm64 0c0-35.3 28.7-64 64-64s64 28.7 64 64l0 64c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-64z"
            ></path>
            <path
              className="fa-primary"
              fill="currentColor"
              d="M206 52.8C201.3 40.3 189.3 32 176 32s-25.3 8.3-30 20.8L2 436.8c-6.2 16.5 2.2 35 18.7 41.2s35-2.2 41.2-18.7L96.2 368l159.6 0L290 459.2c6.2 16.5 24.7 24.9 41.2 18.7s24.9-24.6 18.7-41.2L206 52.8zM231.8 304l-111.6 0L176 155.1 231.8 304z"
            ></path>
          </g>
        </svg>
      </div>
      <div className="w-2/3 inline-block">
        <div
          style={{
            /* @ts-expect-error - TS doesn't recognize `anchor-name` yet */
            anchorName: '--tooltip',
            container: 'slider / inline-size',
            width: '100%',
          }}
        >
          <input
            type="range"
            min={10}
            max={40}
            value={value}
            aria-label="text size slider between 10 and 40"
            style={{ width: '100%' }}
            onChange={(e) => {
              console.log(e, e.target, e.target.value)
              setValue(e.target.value)
            }}
            onMouseEnter={() => {
              tooltipRef.current?.showPopover?.()
            }}
            onMouseLeave={() => {
              tooltipRef.current?.hidePopover?.()
            }}
          />
        </div>
        <div
          ref={tooltipRef}
          popover="manual"
          className="native-tooltip el-popper is-dark"
          /* @ts-expect-error - TS doesn't recognize CSS variables */
          style={{ '--percent': ((value - 10) / 30) * 100 }}
          // style={{ transform: `translateX(${(value - 10) / 40})` }}
        >
          {value}
        </div>
      </div>
      <div className="w-1/6 inline-block text-right">
        <svg
          className="svg-inline--fa fa-font-case fa-lg"
          aria-hidden="true"
          focusable="false"
          data-prefix="fad"
          data-icon="font-case"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 640 512"
        >
          <g className="fa-duotone-group">
            <path
              className="fa-secondary"
              fill="currentColor"
              d="M384 288l0 64c0 70.7 57.3 128 128 128c24.5 0 47.4-6.9 66.8-18.8c5 11.1 16.2 18.8 29.2 18.8c17.7 0 32-14.3 32-32l0-96 0-64 0-96c0-17.7-14.3-32-32-32c-13 0-24.1 7.7-29.2 18.8C559.4 166.9 536.5 160 512 160c-70.7 0-128 57.3-128 128zm64 0c0-35.3 28.7-64 64-64s64 28.7 64 64l0 64c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-64z"
            ></path>
            <path
              className="fa-primary"
              fill="currentColor"
              d="M206 52.8C201.3 40.3 189.3 32 176 32s-25.3 8.3-30 20.8L2 436.8c-6.2 16.5 2.2 35 18.7 41.2s35-2.2 41.2-18.7L96.2 368l159.6 0L290 459.2c6.2 16.5 24.7 24.9 41.2 18.7s24.9-24.6 18.7-41.2L206 52.8zM231.8 304l-111.6 0L176 155.1 231.8 304z"
            ></path>
          </g>
        </svg>
      </div>
    </div>
  )
}

function calculateTranslationPercentageFromCenter(
  value: number,
  min: number,
  max: number
) {
  const middle = (max - min) / 2 + min
  const normalizedValue = value - middle
  const percent = normalizedValue / middle
  return `${percent}%`
}
